export default __webpack_public_path__ + "static/media/bgm-006.bee8a14f.mp3";